{
  "entity": {
    "announcement": "ประกาศ",
    "api_key": "กุญแจแอปอื่น",
    "attribute_definition": "รายละเอียดสินค้าเพิ่ม",
    "audit_log": "ประวัติการแก้ไข",
    "background_job": "งานเบื้องหลัง",
    "bank_import_batch": "ไฟล์ธนาคาร",
    "bank_import_line": "บรรทัดไฟล์ธนาคาร",
    "brand": "แบรนด์",
    "bulk_job": "การแก้ทีละหลายรายการ",
    "buylist_intake": "การรับซื้อ (買取)",
    "card": "การ์ด",
    "card_set": "ชุดการ์ด",
    "carrier": "บริษัทขนส่ง",
    "cash_movement": "เงินเข้า/ออก",
    "category": "หมวดหมู่",
    "collection": "คอลเลกชัน",
    "condition_export_map": "ตารางสภาพสำหรับมาร์เก็ต",
    "consignment_intake": "การรับฝากขาย",
    "consignment_item": "การ์ดฝากขาย",
    "consignment_report": "รายงานฝากขาย",
    "consignment_return": "การคืนของให้ผู้ฝาก",
    "consignment_sale": "การขายของฝาก",
    "consignor": "ผู้ฝากขาย",
    "customer": "ลูกค้า",
    "dead_letter": "การอัปเดตที่ส่งไม่ถึง",
    "discount": "โค้ดส่วนลด",
    "document": "เอกสาร",
    "document_export_job": "การดาวน์โหลดเอกสาร",
    "dsar": "คำขอข้อมูลส่วนบุคคล",
    "dsar_request": "คำขอข้อมูลส่วนบุคคล",
    "edc_settlement_batch": "ใบแจ้งยอดเครื่องรูดบัตร",
    "edc_statement_line": "บรรทัดใบแจ้งยอดเครื่องรูด",
    "event": "การอัปเดตของระบบ",
    "export_evidence": "หลักฐานส่งออก",
    "export_job": "การดาวน์โหลด",
    "facet_config": "ตัวกรองการค้นหา",
    "fx_rate": "อัตราแลกเปลี่ยน",
    "game": "เกมการ์ด",
    "identity_check": "การตรวจบัตร (本人確認)",
    "import_job": "การนำเข้าไฟล์",
    "inbox_item": "งานที่ต้องทำ",
    "inventory_item": "รายการสต็อก",
    "kobutsu_export": "การดาวน์โหลด 古物台帳",
    "kobutsu_ledger": "古物台帳",
    "label_job": "การพิมพ์ฉลาก",
    "legal_calendar": "ปฏิทินกฎหมาย",
    "localization": "ภาษาของเว็บ",
    "mail_settings": "การส่งอีเมล",
    "market": "กลุ่มประเทศ",
    "media_asset": "รูป",
    "media_folder": "โฟลเดอร์รูป",
    "media_item": "รูป",
    "media_tag": "แท็กรูป",
    "menu": "เมนูของเว็บ",
    "not_found_hit": "ที่อยู่เว็บที่ไม่พบ",
    "notification": "อีเมล",
    "notification_preference": "การเลือกรับอีเมล",
    "notification_setting": "การตั้งค่าการแจ้งเตือน",
    "notification_template": "ข้อความอีเมล",
    "offline_batch": "การขายตอนออฟไลน์",
    "offline_op": "การทำงานตอนออฟไลน์",
    "order": "ออเดอร์",
    "order_export": "การดาวน์โหลดออเดอร์",
    "order_line": "บรรทัดออเดอร์",
    "order_setting": "การตั้งค่าออเดอร์",
    "oversell_conflict": "การ์ดขายซ้ำ",
    "page": "หน้าเว็บ",
    "payment": "การชำระเงิน",
    "payment_export": "การดาวน์โหลดการชำระเงิน",
    "payment_method_config": "วิธีรับเงิน",
    "payments_ledger": "สมุดการชำระเงิน",
    "payout": "การจ่ายผู้ฝาก",
    "payout_batch": "ชุดจ่ายผู้ฝาก",
    "policy": "หน้ากฎของร้าน",
    "pos_cart": "ตะกร้าที่เครื่อง",
    "pos_device": "เครื่องคิดเงิน",
    "pos_hold": "การขายที่พักไว้",
    "pos_sale": "การขายที่เครื่อง",
    "pos_setting": "กฎเครื่องคิดเงิน",
    "product": "สินค้า",
    "receipt": "ใบเสร็จ",
    "redirect": "การส่งต่อที่อยู่เก่า",
    "redirect_import": "การส่งต่อจากไฟล์",
    "refund": "การคืนเงิน",
    "register": "เครื่องคิดเงิน",
    "reservation": "การจอง",
    "revalidation": "การรีเฟรชเว็บ",
    "role": "บทบาท",
    "saved_view": "มุมมองที่บันทึก",
    "search_index": "การค้นหาบนเว็บ",
    "search_settings": "การตั้งค่าการค้นหา",
    "section_group": "ส่วนของดีไซน์เว็บ",
    "section_manifest": "ชิ้นส่วนดีไซน์เว็บ",
    "security_incident": "เหตุการณ์ความปลอดภัย",
    "service": "ส่วนของระบบ",
    "shift": "กะเครื่องคิดเงิน",
    "shipping_rate": "วิธีส่ง",
    "shipping_zone": "พื้นที่จัดส่ง",
    "signing_key": "กุญแจความปลอดภัย",
    "staff": "พนักงาน",
    "staff_user": "พนักงาน",
    "stock_discrepancy": "สต็อกไม่ตรง",
    "store_credit_ledger": "เครดิตร้าน",
    "store_credit_lot": "เครดิตร้าน",
    "store_credit_snapshot": "เครดิตร้าน",
    "synonym_set": "คำค้นที่มีความหมายเดียวกัน",
    "tax": "ภาษี",
    "tax_calculation": "การคำนวณภาษี",
    "tax_free_customs_import": "ไฟล์ศุลกากร (免税)",
    "tax_free_export_batch": "ไฟล์ 免税 ส่งสรรพากร",
    "tax_free_passport": "พาสปอร์ต (免税)",
    "tax_free_record": "การขายปลอดภาษี",
    "tax_free_verification": "การตรวจ 免税",
    "tax_setting": "การตั้งค่าภาษี",
    "taxfree_record": "การขายปลอดภาษี",
    "template": "เลย์เอาต์หน้า",
    "theme": "ดีไซน์เว็บ",
    "translation": "คำแปล",
    "translations": "คำแปล",
    "ui_strings": "ข้อความบนเว็บ",
    "variant": "รายการขาย",
    "webhook_endpoint": "การเชื่อมแอปอื่น",
    "retention_job": "การล้างข้อมูลอัตโนมัติตามระยะเก็บ"
  },
  "entity_other": "รายการ",
  "audit": {
    "title": "ประวัติการแก้ไข",
    "intro": "ใครทำอะไร เมื่อไร เปิดบรรทัดเพื่อดูว่าเปลี่ยนอะไรบ้าง",
    "default_range": "แสดง {{days}} วันล่าสุด ถ้าไม่ได้เลือกวันที่",
    "time": "เวลา",
    "who": "ใคร",
    "what": "เกิดอะไรขึ้น",
    "record": "รายการ",
    "ip": "ที่อยู่ที่เข้ามา",
    "filter_record": "ประเภทรายการ",
    "filter_who": "พนักงาน",
    "filter_kind_of_who": "ทำโดย",
    "filter_area": "ส่วนของร้าน",
    "filter_dates": "วันที่",
    "filter_id": "เลขรายการ",
    "actor": {
      "staff": "พนักงาน",
      "customer": "ลูกค้า",
      "system": "ระบบ",
      "service": "ระบบ",
      "api_key": "แอปอื่น",
      "pos": "เครื่องคิดเงิน"
    },
    "area": {
      "catalog": "สินค้า",
      "inventory": "สต็อก",
      "orders": "ออเดอร์",
      "payments": "การชำระเงิน",
      "pos": "เครื่องคิดเงิน",
      "consignment": "ฝากขาย",
      "tax": "ภาษี",
      "cms": "เว็บ",
      "identity": "พนักงานและการล็อกอิน",
      "notification": "การแจ้งเตือน",
      "media": "รูปและเอกสาร",
      "search": "การค้นหาบนเว็บ"
    },
    "verb": {
      "created": "สร้าง{{what}}",
      "updated": "แก้{{what}}",
      "deleted": "ลบ{{what}}",
      "status": "เปลี่ยนสถานะ{{what}}",
      "viewed": "ดูหรือดาวน์โหลด{{what}}",
      "signin": "ล็อกอิน / ความปลอดภัย: {{what}}",
      "price": "เปลี่ยนราคา{{what}}",
      "price_from_to": "เปลี่ยนราคา{{what}} {{from}} → {{to}}"
    },
    "open_record": "เปิดรายการ",
    "no_fields": "ไม่ได้เก็บรายละเอียดช่องของการแก้ไขนี้",
    "technical_hidden": "ข้อมูลของระบบเปลี่ยนด้วย {{count}} รายการ (ไม่แสดง)",
    "field": "ช่อง",
    "before": "ก่อน",
    "after": "หลัง",
    "hidden": "ซ่อน",
    "export_failed": "สร้างไฟล์ไม่ได้ ลองช่วงวันที่สั้นลง",
    "fields": {
      "price": "ราคา",
      "compareAtPrice": "ราคาก่อนลด",
      "status": "สถานะ",
      "title": "ชื่อเรื่อง",
      "name": "ชื่อ",
      "email": "อีเมล",
      "phone": "โทรศัพท์",
      "address": "ที่อยู่",
      "note": "โน้ต",
      "quantity": "จำนวน",
      "rawRank": "Rank",
      "permissions": "สิ่งที่ทำได้",
      "roleId": "บทบาท",
      "active": "ใช้งาน",
      "tags": "แท็ก",
      "fee": "ค่าธรรมเนียม",
      "feePercent": "ค่าธรรมเนียม %",
      "amount": "ยอดเงิน"
    }
  },
  "jobs": {
    "title": "งานเบื้องหลังและการสำรองข้อมูล",
    "intro": "งานที่ระบบทำเอง: ทำงานอยู่ไหม มีอะไรล้มเหลวไหม สำรองข้อมูลล่าสุดเมื่อไร",
    "problems_title": "ปัญหาของงานเบื้องหลัง",
    "problems_count_other": "ค้าง {{count}} รายการ",
    "problems_none": "ไม่มี",
    "to_inbox": "เปิดปัญหาในรายการงาน",
    "scheduled_title": "งานตามเวลา",
    "never": "ยังไม่เคยรัน",
    "took": "ใช้ {{seconds}} วิ",
    "run_now": "รันตอนนี้ (今すぐ実行)",
    "started": "เริ่ม “{{name}}” แล้ว",
    "run_failed": "เริ่มงานไม่ได้",
    "confirm_title": "รัน “{{name}}” ตอนนี้?",
    "confirm_body": "จะรัน 1 ครั้งตอนนี้ นอกเหนือจากเวลาปกติ",
    "status": {
      "ok": "เสร็จ",
      "failed": "ล้มเหลว",
      "running": "กำลังรัน",
      "never": "ยังไม่เคยรัน",
      "queued": "รอทำงาน",
      "stuck": "ค้างอยู่"
    },
    "names": {
      "all": {
        "purge_expired_plumbing": "ล้างบันทึกระบบเก่า"
      },
      "catalog": {
        "publish_scheduled": "เปิดขายสินค้าที่ตั้งเวลาไว้",
        "purge_deleted_products": "ลบสินค้าที่ลบไปนานแล้วออกถาวร",
        "purge_expired_exports": "ลบไฟล์ดาวน์โหลดเก่า",
        "recheck_compare_at": "ตรวจราคาเปรียบเทียบอีกครั้ง (景品表示法)",
        "refresh_smart_collections_all": "อัปเดตคอลเลกชันอัตโนมัติ",
        "retry_stalled_jobs": "ลองนำเข้า/ส่งออกที่ค้างอีกครั้ง"
      },
      "cms": {
        "announcement_schedule": "แสดง/ซ่อนประกาศตามเวลาที่ตั้ง",
        "backup_content": "สำรองเนื้อหาเว็บไซต์",
        "cms_housekeeping": "เก็บกวาดฉบับร่างเว็บไซต์เก่า",
        "media_usage_refresh": "นับใหม่ว่ารูปถูกใช้ที่ไหน",
        "publish_scheduled_pages": "เผยแพร่หน้าที่ตั้งเวลาไว้",
        "scheduled_publish": "เผยแพร่การแก้ไขเว็บไซต์ที่ตั้งเวลาไว้"
      },
      "consignment": {
        "consignment_expiry": "ระยะฝากขายที่ครบกำหนด",
        "consignment_items_closer": "ปิดของฝากขายที่จบแล้ว",
        "consignment_stage_gauge": "นับของฝากขายแต่ละขั้น",
        "identity_retention_purge": "ลบสำเนาบัตรที่พ้นระยะเก็บ",
        "intake_documents_sweeper": "ทำเอกสารรับฝากให้เสร็จ",
        "items_catalog_sweeper": "ผูกของฝากขายกับสินค้า",
        "kobutsu_completeness_check": "ตรวจ 古物台帳 ว่ากรอกครบ",
        "kobutsu_retention_report": "รายงานการเก็บ 古物台帳 รายเดือน",
        "payout_schedule": "เตรียมจ่ายเงินผู้ฝากขาย",
        "payout_statement_sweeper": "ทำใบแจ้งการจ่ายเงิน",
        "price_proposals_sweeper": "ปิดข้อเสนอราคาที่ไม่มีคำตอบ",
        "returns_sweeper": "ติดตามการคืนของให้ผู้ฝากขาย",
        "settlements_sweeper": "สรุปยอดของฝากขายที่ขายได้"
      },
      "identity": {
        "audit_maintenance": "ปิดผนึกและเก็บประวัติการแก้ไข",
        "dsar_follow_up": "ติดตามคำขอข้อมูลส่วนบุคคล",
        "purge_expired_identity": "ลบลิงก์/รหัสเข้าสู่ระบบที่หมดอายุ"
      },
      "inventory": {
        "reconcile_ledger": "ตรวจตัวเลขสต็อก"
      },
      "media": {
        "document_integrity": "ตรวจว่าเอกสารที่เก็บไว้ไม่เสียหาย",
        "document_retention": "ลบเอกสารที่พ้นระยะเก็บ",
        "expire_document_exports": "ลบไฟล์ดาวน์โหลดเอกสารเก่า",
        "gc_orphans": "ลบไฟล์อัปโหลดที่ไม่ได้ใช้",
        "refresh_storage_bytes": "นับพื้นที่เก็บไฟล์ใหม่",
        "requeue_stuck_assets": "ลองประมวลผลรูปที่ค้างอีกครั้ง",
        "restricted_retention": "ลบรูปบัตรที่พ้นระยะเก็บ",
        "retry_stuck_documents": "ลองทำใบเสร็จ/PDF ที่ค้างอีกครั้ง"
      },
      "notification": {
        "notification_tick": "ส่งการเตือน สรุป และอีเมลที่รอส่ง"
      },
      "orders": {
        "expire_carts": "ล้างตะกร้าเก่า",
        "expire_checkouts": "ปล่อยการสั่งซื้อที่ไม่เสร็จ",
        "expire_order_tokens": "ปิดลิงก์ติดตามออเดอร์เก่า",
        "import_jp_postal": "อัปเดตรหัสไปรษณีย์ญี่ปุ่น",
        "remind_uncollected_pickups": "เตือนออเดอร์รับที่ร้านที่ยังไม่มารับ",
        "saga_compensate": "ยกเลิกการสั่งซื้อที่ชำระเงินไม่สำเร็จ"
      },
      "payments": {
        "expire_bank_transfers": "ยกเลิกการโอนที่ไม่จ่ายภายในกำหนด",
        "expire_store_credit": "ปิดเครดิตร้านที่หมดอายุ",
        "payments_ledger_check": "ตรวจการรับเงินกับสมุดบัญชี",
        "store_credit_kijunbi_snapshot": "ยอดเครดิตร้าน ณ 基準日 (資金決済法)"
      },
      "search": {
        "purge_search_query_log": "ลบคำค้นเก่า",
        "search_consistency_check": "ตรวจว่าการค้นหาบนเว็บครบ",
        "search_recover_stalled": "ลองอัปเดตการค้นหาที่ค้างอีกครั้ง",
        "sync_collection_members": "อัปเดตคอลเลกชันในการค้นหา"
      },
      "tax": {
        "calendar_alerts": "เตือนวันสำคัญด้านภาษี/กฎหมาย",
        "evidence_reminder": "เตือนหลักฐานส่งออกที่ยังขาด",
        "purge_pii": "ลบข้อมูลส่วนบุคคลที่พ้นระยะเก็บ",
        "refresh_fx": "อัปเดตอัตราแลกเปลี่ยน",
        "tax_reconcile": "ตรวจบันทึกภาษีกับออเดอร์",
        "taxfree_expire": "ปิดรายการปลอดภาษีเมื่อครบ 90 วัน",
        "taxfree_transmit": "ส่งข้อมูลการซื้อปลอดภาษี"
      },
      "realtime": {
        "purge_connection_audit": "ลบบันทึกการเชื่อมต่ออัปเดตสดเก่า"
      }
    },
    "next": "รอบถัดไป:",
    "already_waiting": "“{{name}}” รอทำงานอยู่แล้ว",
    "already_running": "“{{name}}” กำลังทำงานอยู่ — ลองอีกครั้งเมื่อเสร็จแล้ว",
    "not_allowed": "งานนี้สั่งทำเองไม่ได้",
    "stuck_stopped": "งานหยุดกลางคัน (ส่วนที่ทำงานนี้ถูกรีสตาร์ต) กด “รันตอนนี้” เพื่อเริ่มใหม่",
    "stuck_not_picked_up": "รอมานานแล้ว — ส่วนที่ทำงานนี้อาจหยุดอยู่ ให้ IT ช่วยตรวจ",
    "could_not_read": "อ่านรายการงานไม่ได้ตอนนี้ ระบบจะลองใหม่เอง",
    "unreachable": "ไม่มีคำตอบจาก: {{parts}} — งานของส่วนนี้ไม่แสดงด้านล่าง",
    "not_connected_parts": "ยังไม่ได้เชื่อม: {{parts}}",
    "small_title_one": "งานเล็ก {{count}} งานที่ทำทุกชั่วโมงหรือถี่กว่า",
    "small_title_other": "งานเล็ก {{count}} งานที่ทำทุกชั่วโมงหรือถี่กว่า"
  },
  "backups": {
    "title": "การสำรองข้อมูล",
    "last": "สำรองล่าสุด",
    "size": "ขนาด",
    "where": "เก็บที่",
    "next": "สำรองครั้งถัดไป",
    "kept": "เก็บไว้",
    "days_other": "{{count}} วัน",
    "drill": "ทดสอบกู้คืนล่าสุด",
    "drill_ok": "สำเร็จ",
    "drill_failed": "ล้มเหลว",
    "never": "ยังไม่เคย",
    "plan": "การกู้คืนทำโดย IT ตามคู่มือ ({{path}}) — ตั้งใจไม่มีปุ่มกู้คืนที่นี่",
    "state": {
      "ok": "เป็นปัจจุบัน",
      "too_old": "เก่ากว่า {{hours}} ชั่วโมง",
      "never": "ไม่พบข้อมูลสำรอง",
      "unreadable": "อ่านสถานะไม่ได้"
    },
    "could_not_read": "อ่านสถานะการสำรองข้อมูลไม่ได้ตอนนี้ ระบบจะลองใหม่เอง",
    "not_configured": "เซิร์ฟเวอร์นี้ยังไม่ได้ตั้งค่าการแสดงสถานะสำรองข้อมูล ระบบสำรองข้อมูลทุกคืนเวลา {{time}} (เวลาญี่ปุ่น) และเก็บไว้ {{days}} วัน",
    "unreadable": "อ่านไฟล์สถานะการสำรองข้อมูลไม่ได้ — ให้ IT ตรวจที่เก็บข้อมูลสำรอง",
    "last_try_failed": "การสำรองข้อมูลครั้งล่าสุดล้มเหลว:",
    "encrypted": "เข้ารหัสแล้ว",
    "storage": {
      "online": "พื้นที่เก็บออนไลน์ ({{name}})",
      "online_unnamed": "พื้นที่เก็บออนไลน์",
      "this_server": "เก็บไว้ในเซิร์ฟเวอร์นี้เท่านั้น"
    }
  },
  "health": {
    "title": "ทุกอย่างทำงานอยู่ไหม?",
    "all_ok": "ทุกอย่างทำงานปกติ",
    "some_down_other": "มีปัญหา {{count}} ส่วน",
    "ok": "ทำงาน",
    "no_answer": "ไม่ตอบ",
    "problem_with": "ปัญหา: {{what}}",
    "build": "เวอร์ชันหลังบ้าน: {{release}}",
    "uptime": "หน้ามอนิเตอร์",
    "errors": "รายงานข้อผิดพลาด",
    "check": {
      "database": "ฐานข้อมูล",
      "nats": "ระบบส่งข้อความ"
    },
    "service": {
      "identity": "พนักงานและการล็อกอิน",
      "catalog": "สินค้า",
      "inventory": "สต็อก",
      "tax": "ภาษี",
      "orders": "ออเดอร์และการส่ง",
      "payments": "การชำระเงิน",
      "pos": "เครื่องคิดเงิน",
      "consignment": "ฝากขาย",
      "cms": "เนื้อหาเว็บ",
      "media": "รูปและเอกสาร",
      "search": "การค้นหาบนเว็บ",
      "notification": "อีเมลและรายการงาน",
      "realtime": "การอัปเดตสด"
    }
  },
  "features": {
    "title": "ฟีเจอร์ที่จะมาภายหลัง",
    "intro": "การเชื่อมกับแพลตฟอร์มอื่นจะทำในเฟสถัดไป จนกว่าจะถึงตอนนั้นจะปิดไว้",
    "when": "จะเปิดเมื่อเจ้าของสั่งและงานเฟสนั้นเสร็จ — ไม่มีสวิตช์ที่หน้านี้",
    "error": "อ่านสถานะสวิตช์ไม่ได้ในขณะนี้ — จึงแสดงเป็น \"ปิด\" ทั้งหมด",
    "on": "เปิด",
    "off": "ปิด",
    "where": "จะแสดงที่ไหน",
    "names": {
      "payments__stripe": "รับบัตรบนเว็บ (Stripe)",
      "payments__stripe_connect": "จ่ายผู้ฝากขายผ่าน Stripe",
      "channels__ebay": "eBay",
      "channels__whatnot": "Whatnot",
      "channels__mercari": "Mercari",
      "channels__tiktok_shop": "TikTok Shop",
      "tax__nta_api": "ส่งข้อมูล 免税 ให้สรรพากรออนไลน์",
      "shipping__shipandco": "ใบปะหน้าพัสดุ (Ship&co)",
      "shipping__zonos": "ภาษีนำเข้าตอนสั่งซื้อ (Zonos)"
    }
  },
  "refresh": {
    "title": "รีเฟรชเว็บ",
    "intro": "หลังแก้ไข ร้านจะบอกเว็บว่าส่วนไหนต้องแสดงใหม่ ที่นี่ดูได้ว่าไปถึงหรือยัง และส่งอีกครั้งได้",
    "todo": "เว็บอาจยังไม่อัปเดต",
    "todo_close": "ทำเสร็จแล้ว",
    "todo_done": "ปิดงานแล้ว",
    "manual_title": "รีเฟรชบางส่วนของเว็บตอนนี้",
    "manual_intro": "ใช้เมื่อเว็บยังแสดงข้อมูลเก่า",
    "refresh_part": "รีเฟรช: {{part}}",
    "part_sent": "ส่งรีเฟรช{{part}}แล้ว",
    "error": "โหลดประวัติการรีเฟรชไม่ได้",
    "empty": "ยังไม่มีการรีเฟรช",
    "not_configured": "ยังไม่ได้ตั้งการเชื่อมกับเว็บ — ไม่ได้ส่งรีเฟรช (IT)",
    "send_again": "ส่งอีกครั้ง",
    "sent_again": "ส่งอีกครั้งแล้ว — ปกติถึงภายในไม่กี่วินาที",
    "status": {
      "done": "สำเร็จ",
      "retrying": "กำลังลองใหม่",
      "failed": "ยังไม่สำเร็จ (ลองเองอยู่)",
      "stopped": "หยุดลองแล้ว",
      "joined": "ถูกรวมไปกับรอบถัดไป",
      "waiting": "กำลังส่ง",
      "off": "ปิดอยู่"
    },
    "parts": {
      "design": "ดีไซน์เว็บ",
      "page": "หน้าเว็บ",
      "rules": "หน้ากฎของร้าน",
      "menu": "เมนู",
      "redirects": "ที่อยู่เว็บเก่า",
      "announcements": "ประกาศ",
      "texts": "ข้อความบนเว็บ",
      "languages": "ภาษาของเว็บ",
      "products": "สินค้า",
      "collections": "คอลเลกชัน",
      "other": "ส่วนอื่น"
    },
    "for_it": "รายละเอียดสำหรับ IT",
    "it_tags": "แท็ก",
    "it_attempts": "จำนวนครั้ง",
    "it_answer": "รหัสตอบกลับ",
    "it_error": "ข้อผิดพลาด"
  }
}
